module.exports = __webpack_public_path__ + "static/media/Shoes_2.6719f7f9.jpg";